import { render, staticRenderFns } from "./StockableProductCard.vue?vue&type=template&id=6104247e&scoped=true&"
import script from "./StockableProductCard.vue?vue&type=script&lang=js&"
export * from "./StockableProductCard.vue?vue&type=script&lang=js&"
import style0 from "./StockableProductCard.vue?vue&type=style&index=0&id=6104247e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6104247e",
  null
  
)

export default component.exports